import React from 'react'
import { FormGroup, CustomInput } from "reactstrap"
import { Controller } from 'react-hook-form'

const CheckField = (props) => {
  const { formRef } = props

  return (
    <FormGroup>
      <Controller
        name={
          props.index !== undefined && props !== null
            ? `${props.name}[${props.index}]`
            : props.name
        }
        control={formRef.control}
        defaultValue={false}
        render={ctrl => (
          <CustomInput
            id={props.id}
            type='checkbox'
            className='custom-control-Primary'
            label={props.title}
            checked={ctrl.value}
            onChange={e => ctrl.onChange(e.target.checked)}
          />
        )}
      />
    </FormGroup>
  )
}

export default CheckField
